var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.75H6C5.80109 0.75 5.61032 0.829018 5.46967 0.96967C5.32902 1.11032 5.25 1.30109 5.25 1.5C5.25 1.69891 5.32902 1.88968 5.46967 2.03033C5.61032 2.17098 5.80109 2.25 6 2.25H8.6895L2.25 8.6895V6C2.25 5.80109 2.17098 5.61032 2.03033 5.46967C1.88968 5.32902 1.69891 5.25 1.5 5.25C1.30109 5.25 1.11032 5.32902 0.96967 5.46967C0.829018 5.61032 0.75 5.80109 0.75 6V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H6C6.19891 11.25 6.38968 11.171 6.53033 11.0303C6.67098 10.8897 6.75 10.6989 6.75 10.5C6.75 10.3011 6.67098 10.1103 6.53033 9.96967C6.38968 9.82902 6.19891 9.75 6 9.75H3.3105L9.75 3.3105V6C9.75 6.19891 9.82902 6.38968 9.96967 6.53033C10.1103 6.67098 10.3011 6.75 10.5 6.75C10.6989 6.75 10.8897 6.67098 11.0303 6.53033C11.171 6.38968 11.25 6.19891 11.25 6V1.5C11.25 1.30109 11.171 1.11032 11.0303 0.96967C10.8897 0.829018 10.6989 0.75 10.5 0.75Z",
    fill: "url(#paint0_linear_214_3208)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_3208",
    x1: 6,
    y1: 0.75,
    x2: 6,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandicon);
export default __webpack_public_path__ + "static/media/expandicon.1cab14fbc7e303e41493925641d9bb91.svg";
export { ForwardRef as ReactComponent };